import { render } from "./posView.vue?vue&type=template&id=28d65298&scoped=true"
import script from "./posView.vue?vue&type=script&lang=js"
export * from "./posView.vue?vue&type=script&lang=js"

import "./posView.vue?vue&type=style&index=0&id=28d65298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d65298"]])

export default __exports__